import React from 'react';

interface LegendProps {
    visibleTypes: string[];
    onToggleType: (type: string) => void;
}

const Legend: React.FC<LegendProps> = ({ visibleTypes, onToggleType }) => {
    const isAllowedVisible = visibleTypes.includes('allowed');
    const isProhibitedVisible = visibleTypes.includes('prohibited');

    return (
        <div style={{
            position: 'absolute',
            bottom: '40px',
            right: '20px',
            background: '#242A65',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            padding: '15px',
            borderRadius: '12px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
            zIndex: 1,
            fontSize: '13px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            color: '#fff',
            border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
            <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', fontWeight: 600 }}>Food Truck Areas</h4>
            <div 
                style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    marginBottom: '8px', 
                    cursor: 'pointer',
                    opacity: isAllowedVisible ? 1 : 0.5,
                    transition: 'opacity 0.2s'
                }}
                onClick={() => onToggleType('allowed')}
            >
                <span style={{ 
                    width: '18px', 
                    height: '18px', 
                    backgroundColor: '#2ecc71', 
                    display: 'inline-block', 
                    marginRight: '10px', 
                    borderRadius: '4px',
                    border: '1.5px solid #27ae60' 
                }}></span>
                <span style={{ fontWeight: 500 }}>Allowed</span>
            </div>
            <div 
                style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    cursor: 'pointer',
                    opacity: isProhibitedVisible ? 1 : 0.5,
                    transition: 'opacity 0.2s'
                }}
                onClick={() => onToggleType('prohibited')}
            >
                <span style={{ 
                    width: '18px', 
                    height: '18px', 
                    backgroundColor: '#e74c3c', 
                    display: 'inline-block', 
                    marginRight: '10px', 
                    borderRadius: '4px',
                    border: '1.5px solid #c0392b' 
                }}></span>
                <span style={{ fontWeight: 500 }}>Prohibited</span>
            </div>
        </div>
    );
};

export default Legend;
